
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoalibaugcabs() {



    const cardData =
    {
        keyword: 'Pune to Alibag Cabs',
        heading: 'Platinum24 Cabs: Pune to Alibag Cabs',
        headingDescription: ' Platinum24 Cabs provides convenient Pune to Alibag Cabs, perfect for beach holidays, family outings, and weekend getaways. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable journey along the scenic Konkan routes, with spacious interiors and smooth rides. With professional chauffeurs, punctual service, and affordable one-way or round-trip packages, we make your Pune to Alibag travel hassle-free. Whether you’re planning to relax at Alibag Beach, explore Kolaba Fort, or enjoy coastal homestays, Platinum24 Cabs guarantees safe, reliable, and enjoyable cab services every time.',

        top: 'Top Places to Visit in Alibag with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Alibaug Beach",
    "description": "Alibaug Beach is the town’s most popular coastal stretch, offering panoramic views of the Arabian Sea and the historic Kolaba Fort. Tourists enjoy horse rides, camel rides, and beach cricket here. The beach is lively with food stalls selling bhel puri, pav bhaji, and coconut water. Sunsets are stunning with golden skies. The atmosphere is vibrant yet relaxed. Alibaug Beach is the heart of the town’s seaside charm."
  },
  {
    "title": "Kolaba Fort",
    "description": "Kolaba Fort, built by Chhatrapati Shivaji Maharaj in 1680, is located just offshore from Alibaug Beach. Accessible by foot during low tide and by boat during high tide, it offers a unique experience. The fort has temples, freshwater wells, and ramparts. It was once a naval base for the Marathas. Tourists admire its history and scenic sea views. Kolaba Fort is Alibaug’s proud heritage landmark."
  },
  {
    "title": "Kihim Beach",
    "description": "Kihim Beach is known for its clean sands, coconut groves, and peaceful environment. It is less crowded than Alibaug Beach, making it ideal for nature lovers. Birdwatchers enjoy spotting rare species here. Beach resorts and homestays provide comfortable stays. Tourists also explore nearby villages for authentic Konkani culture. Kihim is Alibaug’s tranquil seaside escape."
  },
  {
    "title": "Nagaon Beach",
    "description": "Nagaon Beach is a hub for water sports like jet skiing, parasailing, and banana boat rides. The long sandy stretch is perfect for family outings and picnics. Lined with betel nut and coconut trees, it offers a scenic setting. Horse carts and quad bikes add fun for kids. It is one of the most active beaches in the region. Nagaon Beach is Alibaug’s adventure and leisure destination."
  },
  {
    "title": "Kashid Beach",
    "description": "Kashid Beach, 30 km from Alibaug, is known for its white sand and turquoise waters. It is one of the cleanest beaches in Maharashtra. Surrounded by casuarina trees, it is perfect for camping, horse riding, and water sports. Weekends attract many tourists from Mumbai and Pune. Sunsets here are mesmerizing. Kashid Beach is Alibaug’s picture-perfect coastal paradise."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "Murud-Janjira Fort, located near Alibaug, is a majestic sea fort built in the 15th century. Famous for being unconquered, it was home to the Siddis of Janjira. The fort’s massive walls, bastions, and cannons still stand strong. Accessible by sailboats, the fort offers stunning sea views. Its history and architecture attract thousands of visitors. Murud-Janjira is Alibaug’s timeless maritime wonder."
  },
  {
    "title": "Mandwa Beach",
    "description": "Mandwa Beach is known for its scenic beauty and ferry connectivity with Mumbai. The beach is lined with resorts, villas, and water sports activities. Tourists enjoy swimming, kayaking, and sailing here. It is also a filming location for Bollywood movies. Mandwa serves as the entry point to Alibaug from Mumbai. Mandwa Beach is Alibaug’s vibrant gateway by sea."
  },
  {
    "title": "Revdanda Beach & Fort",
    "description": "Revdanda is a coastal village near Alibaug, famous for its black sand beach and Portuguese-era fort. The fort, though in ruins, is surrounded by coconut groves and sea waves. The village also has historic churches and temples. The calm environment makes it ideal for camping and stargazing. It is a hidden gem for explorers. Revdanda is Alibaug’s mix of history and natural beauty."
  },
  {
    "title": "Varsoli Beach",
    "description": "Varsoli Beach is a quiet beach located close to Alibaug town. Known for its calm waters and fishing boats, it offers a peaceful experience. Families enjoy picnics and short walks here. The beach is lined with casuarina and suru trees. It is less commercialized, attracting those who seek solitude. Varsoli is Alibaug’s serene seaside retreat."
  },
  {
    "title": "Kanakeshwar Temple",
    "description": "Kanakeshwar Temple, located on a hill near Alibaug, is dedicated to Lord Shiva. Visitors climb around 750 steps to reach the temple, surrounded by lush greenery. The trek is rewarding with panoramic views of the sea and villages below. The temple complex has ancient idols, a pond, and smaller shrines. Pilgrims visit during Shivratri in large numbers. Kanakeshwar Temple is Alibaug’s sacred hilltop shrine."
  }
],



   "services": [
    {
      "name": "Pune to Alibag Cab Service",
      "description": "Enjoy a comfortable and hassle-free cab service from Pune to Alibag, ideal for beach lovers, families, and weekend travelers. Our cab services are operated by experienced drivers who know the coastal route well, ensuring a safe and scenic journey. Vehicles are sanitized, GPS-enabled, and offer amenities like charging ports, bottled water, and music systems. Choose from hatchbacks, sedans, SUVs, or luxury cars based on your preferences and group size."
    },
    {
      "name": "Alibag Taxi from Pune",
      "description": "Looking for a dependable taxi from Pune to Alibag? Our intercity taxi service connects you to the beautiful coastal town of Alibag with ease. Ideal for solo travelers, couples, and families, our taxis provide door-to-door pickup, route flexibility, and professional service. All drivers are trained in long-distance driving and local sightseeing support. Customize your journey with stopovers or sightseeing points along the Konkan coast."
    },
    {
      "name": "Pune to Alibag Taxi Booking",
      "description": "Book your Pune to Alibag taxi online or by phone with instant confirmation and a wide range of vehicle options. Our booking system provides real-time updates, digital invoices, and travel support. You can select pickup points across Pune and even schedule early morning or late-night rides. We offer flexible rescheduling, secure payment options, and customer support to ensure a smooth travel experience."
    },
    {
      "name": "Taxi from Pune to Alibag",
      "description": "Hire a taxi from Pune to Alibag for a relaxed and enjoyable ride to the scenic beach destination. Whether you're planning a day trip or an extended stay, we provide comfortable vehicles with AC, legroom, and luggage space. Perfect for group getaways, family beach outings, or peaceful nature retreats. Our drivers know the best routes to avoid traffic and ensure timely arrival."
    },
    {
      "name": "Alibag Cab Rental Pune",
      "description": "Rent a cab from Pune to Alibag with flexible plans including one-way, round trip, hourly, and multi-day rental options. Our fleet includes economy cars, premium sedans, SUVs, and tempo travellers. Every rental comes with a professional chauffeur, fuel, and road tax included. Customize your package with add-ons like beach stops, overnight halts, or sightseeing detours."
    },
    {
      "name": "Pune to Alibag Taxi Fare",
      "description": "Get complete transparency on your Pune to Alibag taxi fare with detailed cost breakdowns for each vehicle type. Fares include fuel, tolls, driver allowance, and state tax. No hidden charges—what you see is what you pay. Choose a car based on your budget and group size, and get quotes instantly. Special discounted fares available for early bookings and return packages."
    },
    {
      "name": "Pune Alibag Private Cab",
      "description": "Choose a private cab from Pune to Alibag for an uninterrupted and personalized travel experience. Avoid shared rides, detours, or delays. Our private cabs ensure privacy, comfort, and safety for families, couples, or corporate travelers. Available in both standard and luxury segments with optional premium features like leather seats, Wi-Fi, or onboard refreshments."
    },
    {
      "name": "Cab Service Pune to Alibag",
      "description": "Professional cab services from Pune to Alibag with verified drivers, clean vehicles, and 24/7 booking support. Our cabs are equipped for long-distance travel with comfortable seating, entertainment options, and AC. Best suited for weekend beach trips, romantic getaways, or quick escapes from city life. Our operations team ensures you get timely service, travel assistance, and live ride tracking."
    },
    {
      "name": "Affordable Cabs Pune to Alibag",
      "description": "Find budget-friendly cabs for your Pune to Alibag trip without compromising on safety or comfort. We offer low-cost hatchbacks, economy sedans, and shared rides with fixed pricing and no surge charges. Perfect for solo or budget-conscious travelers heading for a beach day, local event, or vacation. Discounts available for students and senior citizens on select days."
    },
    {
      "name": "Pune to Alibag Car Hire",
      "description": "Hire a car from Pune to Alibag with options for chauffeur-driven or self-drive rental. Choose the plan that suits your travel needs—whether for a one-day trip, extended vacation, or weekend stay. Cars are available with full insurance, unlimited km options, and additional support like baby seats, roof racks, or onboard Wi-Fi. Ideal for flexible and independent travel plans."
    },
    {
      "name": "Alibag Cab Packages Pune",
      "description": "Explore exclusive cab packages from Pune to Alibag that include round-trip fares, sightseeing, and local travel within Alibag. These packages cover tolls, parking, driver charges, and fuel costs. Perfect for family vacations or group tours who want all-inclusive pricing and pre-planned itineraries. You can customize your travel stops and return timing for added convenience."
    },
    {
      "name": "Pune to Alibag Outstation Taxi",
      "description": "Outstation taxi service from Pune to Alibag, ideal for intercity travel with trained drivers and comfortable vehicles. Choose from AC sedans, SUVs, or tempo travellers for long-distance rides. We follow all safety protocols, provide live tracking, and ensure route optimization. Outstation service includes flexible pickup times, night driving safety, and roadside assistance."
    },
    {
      "name": "Alibag Taxi for Beach Trips Pune",
      "description": "Plan the perfect beach escape with our dedicated taxi services for beach trips from Pune to Alibag. Get dropped at Alibag's top beaches like Varsoli, Nagaon, or Alibag Beach in comfortable AC taxis with beach essentials onboard. Drivers are familiar with beach-side hotels, restaurants, and spots. Great for day-trips or extended beach holidays."
    },
    {
      "name": "Pune to Alibag One Way Cab",
      "description": "Book a one-way cab from Pune to Alibag and pay only for the distance traveled—no return fare required. Ideal for people relocating, vacationers staying longer, or flexible travelers. One-way options are available in sedans, SUVs, and luxury cars, with assured punctual pickup and drop service at any hotel, resort, or homestay in Alibag."
    },
    {
      "name": "Alibag Taxi Rental Pune",
      "description": "Taxi rentals from Pune to Alibag are available for all occasions—weekend holidays, romantic getaways, or spiritual retreats. Rent taxis by the hour, per km, or for full-day plans. Drivers are courteous and trained, and cars are thoroughly sanitized. Special offers available for group bookings, wedding trips, or long weekend packages."
    }
  ],
  "tableData": [
    ["Pune to Alibag Cab Service", "Alibag Taxi from Pune"],
    ["Pune to Alibag Taxi Booking", "Taxi from Pune to Alibag"],
    ["Alibag Cab Rental Pune", "Pune to Alibag Taxi Fare"],
    ["Pune Alibag Private Cab", "Cab Service Pune to Alibag"],
    ["Affordable Cabs Pune to Alibag", "Pune to Alibag Car Hire"],
    ["Alibag Cab Packages Pune", "Pune to Alibag Outstation Taxi"],
    ["Alibag Taxi for Beach Trips Pune", "Pune to Alibag One Way Cab"],
    ["Alibag Taxi Rental Pune", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Affordable Pune to Alibag Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers budget-friendly and reliable cab services for your journey from Pune to Alibag."
    },
    {
      "WhyChooseheading": "On-Time Pickup and Drop for a Hassle-Free Journey",
      "WhyChoosedescription": "Our punctual drivers ensure timely travel so you can enjoy your trip to Alibag without delays."
    },
    {
      "WhyChooseheading": "Comfortable and Clean Vehicles for Long Drives",
      "WhyChoosedescription": "Travel in well-maintained, air-conditioned cabs designed for a smooth and relaxing ride."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with the Pune-Alibag Route",
      "WhyChoosedescription": "Our drivers know the best routes and road conditions to ensure safe and efficient travel."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
      "WhyChoosedescription": "Enjoy clear, all-inclusive pricing covering fuel, tolls, and driver charges—no surprises later."
    },
    {
      "WhyChooseheading": "Flexible One-Way and Round Trip Cab Options",
      "WhyChoosedescription": "Choose the travel plan that fits your schedule, whether it’s a one-way drop or a round trip."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
      "WhyChoosedescription": "Our team is available anytime to help you with bookings, changes, or special requests."
    },
    {
      "WhyChooseheading": "Wide Range of Vehicles to Match Your Travel Needs",
      "WhyChoosedescription": "Pick from hatchbacks, sedans, or SUVs based on your comfort, group size, and luggage."
    }
  ]
























    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Alibag?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Alibag.',
    },
    {
        question: 'How can I book a Pune to Alibag cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Alibag cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Alibag trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Alibag?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Alibag route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Alibag?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Alibag cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Alibag rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Alibag route.',
    },
    {
        question: 'Are safety measures in place for Pune to Alibag cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Alibag travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Alibag?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Alibag routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rahul Sharma',
        feedback: 'The Pune to Alibag cab service by Platinum24 Cabs was comfortable and punctual. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Mehta',
        feedback: 'Booking a cab from Pune to Alibag was easy and hassle-free. The driver was professional and courteous.',
        rating: 5,
    },
];







































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const puneToAlibagCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Alibag Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-alibag-cabs.jpg",
  "description": "Book reliable Pune to Alibag cab service for beach trips, outstation travel, and private hires. Affordable and comfortable cabs with verified drivers at Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-alibag-cabs"
  }
};









    return (
        <div>
<Helmet>
  <title>Pune to Alibag Cabs | Affordable Beach Trip Cabs | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable Pune to Alibag cab service for beach trips, outstation travel, and private hires. Affordable and comfortable cabs with verified drivers at Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Pune to Alibag Cab Service, Alibag Taxi from Pune, Pune to Alibag Taxi Booking, Taxi from Pune to Alibag, Alibag Cab Rental Pune, Pune to Alibag Taxi Fare, Pune Alibag Private Cab, Cab Service Pune to Alibag, Affordable Cabs Pune to Alibag, Pune to Alibag Car Hire, Alibag Cab Packages Pune, Pune to Alibag Outstation Taxi, Alibag Taxi for Beach Trips Pune, Pune to Alibag One Way Cab, Alibag Taxi Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToAlibagCabsSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoalibaugcabs;